// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"8fc3e281","309":"51250f28"}[chunkId] + ".chunk.css";
};